import config from "../config/application"
import { apiCall } from "./common/base.service"
import dictionary from "../config/dictionary"
import permission from "./permissions.service"
const find = "find"

class PaymentDetailService {
  getPaymentDetails = async filter => {
    const url = `${config.data.providers.paymentDetail.url}${find}`
    const userAux = JSON.parse(sessionStorage.getItem("user"))
    const validPermission = await paymentDetailService.getPermissions(
      userAux.id.user.username,
      dictionary.configApp.action.list
    )
    const error = validPermission?.response?.data?.error
    return error ? validPermission : apiCall("post", url, filter.filter)
  }

  getPermissions = (username, action) => {
    return permission.validPermission(
      process.env.REACT_APP_TRANSACTION_PAYMENT,
      username,
      process.env.REACT_APP_SYSTEM_CODE,
      action
    )
  }
}
const paymentDetailService = new PaymentDetailService()
export default paymentDetailService
